import moment from "moment";
import DateUtils from "../../../utils/DateUtils";

const TimeRangeFormatter = (event, fieldFrom, fieldTo)=>{

    const timeFrom = moment(event[fieldFrom]).toDate();
    const timeTo = moment(event[fieldTo]).toDate();

    const isTimeFromValid = event!== null && event!== undefined && (DateUtils.isValidDate(timeFrom))
    const isTimeToValid = event !== null && event !== undefined && (DateUtils.isValidDate(timeTo))

    if (isTimeFromValid) {
        event[fieldFrom] = timeFrom
    } else {
        event= [{
            ...event,
            [fieldFrom]: null
        }];
    }

    if (isTimeToValid) {
        event[fieldTo] = timeTo
    } else {
        event = [{
            ...event,
            [fieldTo]: null
        }];
    }
    return isTimeFromValid && isTimeToValid ? `${moment(event[fieldFrom]).format('HH:mm')}-${moment(event[fieldTo]).format('HH:mm')}` : '-';
}

export default TimeRangeFormatter;